import { useState } from 'react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import Fade from '@mui/material/Fade'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const useStyles = makeStyles((theme: Theme) => ({
    baseMapToggle: {
        position: 'absolute',
        left: '16px',
        top: (props) => `-${props}px`,
    },
    imgBaseMap: {
        width: '100%',
        height: '100%',
        borderRadius: '5px',
    },
    imgListBaseMap: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': {
            border: `2px solid ${theme.palette.text.primary}`,
        },
    },
}))

type BaseMapToggleProps = {
    onBaseMapSelected?: (name?: string) => void
    openBasemapGallery: boolean
    onClickBaseMap?: () => void
    closeBasemapGallery?: (flag: boolean) => void
    positionTop: number
}
const BaseMapToggle = (props: BaseMapToggleProps) => {
    const { onBaseMapSelected, openBasemapGallery, onClickBaseMap, closeBasemapGallery } = props
    const classes = useStyles(props.positionTop)

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
    const [baseMap, setBaseMap] = useState([
        {
            id: 1,
            name: 'streets',
            displayName: 'เส้นถนน',
            url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/basemap_street.png`,
            active: true,
        },
        {
            id: 2,
            //name: 'hybrid',
            name: 'arcgis/imagery',
            displayName: 'ดาวเทียม',
            url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/basemap_imagery.png`,
            active: false,
        },
        {
            id: 3,
            name: 'topo-vector',
            displayName: 'แนวเขา',
            url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/basemap_topo.png`,
            active: false,
        },
    ])

    const handleClickBaseMap = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
        onClickBaseMap?.()
    }

    const handleSelectBaseMap = (id: number) => {
        const data = baseMap.map((item) => {
            if (item.id === id) {
                item.active = true
            } else {
                item.active = false
            }
            return item
        })
        setBaseMap(data)
        closeBasemapGallery?.(false)

        const baseMapName = baseMap.find((item) => item.id === id)?.name
        onBaseMapSelected?.(baseMapName)
    }

    return (
        <>
            <Box className={classes.baseMapToggle}>
                <Paper
                    sx={{ width: 80, height: 80, border: 'none', cursor: 'pointer' }}
                    component="button"
                    onClick={handleClickBaseMap}
                    style={{ paddingTop: '5px' }}
                >
                    {baseMap.map((item, index) => {
                        if (item.active) {
                            return (
                                <div key={index} style={{ position: 'relative' }}>
                                    <img src={item.url} alt="img" className={classes.imgBaseMap} />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: '3px',
                                            justifyContent: 'center',
                                            width: '100%',
                                            backgroundColor: '#00000030',
                                            color: 'white',
                                            borderRadius: '0 0 5px 5px',
                                        }}
                                    >
                                        <Typography variant="caption">{item.displayName}</Typography>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </Paper>
            </Box>
            <Popper open={openBasemapGallery} anchorEl={anchorEl} placement={`right`} transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper sx={{ p: 1, ml: '10px', width: 'fit-content', display: 'flex', gap: '10px' }}>
                            {baseMap.map((item, index) => {
                                if (!item.active) {
                                    return (
                                        <Stack key={index} alignItems="center" style={{ width: '70px' }}>
                                            <img
                                                src={item.url}
                                                alt="img"
                                                className={classes.imgListBaseMap}
                                                onClick={() => handleSelectBaseMap(item.id)}
                                            />
                                            <Typography variant="caption">{item.displayName}</Typography>
                                        </Stack>
                                    )
                                }
                            })}
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    )
}

export default BaseMapToggle
